import { request } from './http';

export interface AuthUser {
  id: string;
  username: string;
  nickname: string;
  description: string;
  avatar: string;
  phone: string;
  createdAt: string;
}

export async function fetchCurrentUser(): Promise<AuthUser> {
  return request<AuthUser>('/auth/me');
}

export async function login(username: string, password: string): Promise<AuthUser> {
  return request<AuthUser>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username, password }),
  });
}

export async function logout(): Promise<void> {
  await request<null>('/auth/logout', { method: 'POST' });
}
